module.exports = __webpack_public_path__ + "static/media/pedido.24076163.svg";